import React from 'react';
import StaticImageWithCTA from "../../StaticImageWithCTA/StaticImageWithCTA";
import { getAcquisitionChannelTrackingValues } from "../../../Utils/LayoutHelper";
export var BuyerIntentLandingPageBanner = function BuyerIntentLandingPageBanner(_ref) {
  var name = _ref.name,
    data = _ref.data,
    metadata = _ref.metadata,
    templateName = _ref.templateName,
    track = _ref.track,
    origin = _ref.origin,
    browsingMode = _ref.browsingMode;
  var _ref2 = data || {},
    _ref2$cta = _ref2.cta,
    _ref2$cta2 = _ref2$cta === void 0 ? {} : _ref2$cta,
    _ref2$cta2$buttons = _ref2$cta2.buttons,
    buttons = _ref2$cta2$buttons === void 0 ? [] : _ref2$cta2$buttons,
    _ref2$content = _ref2.content,
    content = _ref2$content === void 0 ? {} : _ref2$content;
  function handleCTAClick(ctaName) {
    if (!ctaName) {
      return;
    }
    var cta = buttons.find(function (b) {
      return b.name === ctaName;
    });
    if (cta && track) {
      var _ref3 = metadata || {},
        _ref3$trackingDetails = _ref3.trackingDetails,
        _ref3$trackingDetails2 = _ref3$trackingDetails === void 0 ? {} : _ref3$trackingDetails,
        eventInfo = _ref3$trackingDetails2[cta.name];
      var _ref4 = eventInfo || {},
        eventName = _ref4.eventName,
        trackingInfo = _ref4.trackingInfo;
      var total_ads = content.total_ads;
      var otherTrackingParams = Object.assign({
        result_count: total_ads,
        origin: origin,
        browsingMode: browsingMode
      }, getAcquisitionChannelTrackingValues());
      track(eventName, Object.assign(Object.assign({}, otherTrackingParams), trackingInfo));
    }
  }
  return /*#__PURE__*/React.createElement(StaticImageWithCTA, {
    name: name,
    data: data,
    metadata: metadata,
    templateName: templateName,
    onCTAClick: handleCTAClick,
    origin: origin,
    browsingMode: browsingMode
  });
};
export default BuyerIntentLandingPageBanner;